import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppProvidersAutocomplete({ ...props }) {
	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		multiple
		label="Providers"
		placeholder="All Providers"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/provider`}
		{...props}
	/>
}